module.exports = __webpack_public_path__ + "static/media/speaker-thao-mobile.4abb88ac.jpg";